import { Routes, Route, Navigate } from "react-router-dom";
import Login from "./routes/Login";
import Batch from "./routes/Batch";
import Record from "./routes/Record";
import Logout from "./routes/Logout";

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/batch" element={<Batch />} />
      <Route path="/batch/record/:articleId" element={<Record />} />
      <Route path="/logout" element={<Logout />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
